import React from 'react'

import { connect } from 'react-redux'

import { redirect } from 'actions/redirect'
import { trackUTMAndPromoCode } from 'actions/tracking'
import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { applyPromoCodeAndShowModal } from 'routes/Home/homeActions'
import { promo } from 'routes/Home/homeConfig'
import { getPromoBannerState } from 'routes/Home/homeUtils'
import { getPromoBannerText } from 'selectors/features'

import { PromoBanner } from './PromoBanner'

const mapStateToProps = (state, ownProps) => {
  const { isNewReducedPromoCodeEnabled } = ownProps

  const text =
    getPromoBannerText(state) ||
    (isNewReducedPromoCodeEnabled ? promo.reducedBannerText : promo.defaultBannerText)
  const { promoCode, canApplyPromo } = getPromoBannerState(state, isNewReducedPromoCodeEnabled)

  const isLoading = isNewReducedPromoCodeEnabled === null

  return {
    text,
    promoCode,
    canApplyPromo,
    isLoading,
  }
}

const mapDispatchToProps = {
  applyPromoCodeAndShowModal,
  redirect,
  trackUTMAndPromoCode,
}

const PromoBannerConnected = connect(mapStateToProps, mapDispatchToProps)(PromoBanner)

export const PromoBannerContainer = () => {
  const isNewReducedPromoCodeEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_new_reduced_promocode_web_enabled',
  )

  if (isNewReducedPromoCodeEnabled == null) {
    return null
  }

  return <PromoBannerConnected isNewReducedPromoCodeEnabled={isNewReducedPromoCodeEnabled} />
}
